import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Calendar, Clock, Users,User, ChevronLeft, ChevronRight,BarChart3, Eye, X, Check, XCircle, Search, Download, AlertCircle, CheckCircle, XOctagon, HourglassIcon, PieChart, Activity, Edit2, Trash2, Plus } from 'lucide-react';
import authService from '../services/authService';
import bookingService from '../services/bookingService';
import eventService from '../services/eventService';
import CustomAlert from '../components/CustomAlert';
import useCustomAlert from '../hooks/useCustomAlert';
import AdminCreateBookingModal from '../components/AdminCreateBookingModal';
import AdminEditBookingModal from '../components/AdminEditBookingModal';
import AdminEditEventModal from '../components/AdminEditEventModal';

const styles = `
* {
  box-sizing: border-box;
}

:root {
  --primary-gradient: linear-gradient(135deg, #2c5f6f 0%, #1a3d47 100%);
  --secondary-gradient: linear-gradient(135deg, #5A9C9C 0%, #4a8c8c 100%);
  --success-gradient: linear-gradient(135deg, #10b981 0%, #059669 100%);
  --warning-gradient: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  --danger-gradient: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  --purple-gradient: linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%);
  
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.06);
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.08);
  --shadow-lg: 0 8px 30px rgba(0, 0, 0, 0.12);
  --shadow-xl: 0 20px 40px rgba(0, 0, 0, 0.15);
  
  --radius-sm: 0.5rem;
  --radius-md: 0.75rem;
  --radius-lg: 1rem;
  --radius-xl: 1.5rem;
}

.admin-dashboard {
  min-height: 100vh;
  background: linear-gradient(to bottom right, #f8fafc 0%, #e2e8f0 50%, #f1f5f9 100%);
  padding: 2rem 0;
}

.admin-container {
  max-width: 1600px;
  margin: 0 auto;
  padding: 0 1.5rem;
}

.admin-header {
  background: var(--primary-gradient);
  color: white;
  padding: 3rem 2.5rem;
  border-radius: var(--radius-xl);
  margin-bottom: 2.5rem;
  box-shadow: var(--shadow-xl);
  position: relative;
  overflow: hidden;
}
  .create-booking-btn {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 50px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.4);
  transition: transform 0.2s, box-shadow 0.2s;
  z-index: 1000;
}

.create-booking-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 30px rgba(102, 126, 234, 0.6);
}


.admin-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.child-tag.clickable {
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  padding-right: 2rem;
}

.child-tag.clickable:hover {
  background: linear-gradient(135deg, #5A9C9C 0%, #4a8c8c 100%);
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(90, 156, 156, 0.3);
}

.child-tag-icon {
  position: absolute;
  right: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.7;
}

.child-tag.clickable:hover .child-tag-icon {
  opacity: 1;
}

.child-details-modal {
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
}

.child-modal-overlay {
  z-index: 1100;
}

.modal-header-content {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.child-modal-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5A9C9C 0%, #4a8c8c 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  box-shadow: 0 4px 12px rgba(90, 156, 156, 0.3);
}

.modal-subtitle {
  margin: 0;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;
}

.child-modal-body {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.child-info-section {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: var(--radius-lg);
  padding: 1.5rem;
}

.child-section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e5e7eb;
}

.child-section-header svg {
  color: #5A9C9C;
}

.child-section-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1f2937;
}

.child-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.25rem;
}

.child-info-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.child-info-item.full-width {
  grid-column: 1 / -1;
}

.child-info-label {
  font-size: 0.85rem;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.child-info-value {
  font-size: 1rem;
  font-weight: 500;
  color: #1f2937;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: var(--radius-sm);
  border-left: 3px solid #5A9C9C;
}

.child-health-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1rem;
}

.health-card {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 2px solid #f59e0b;
  border-radius: var(--radius-md);
  padding: 1.25rem;
  transition: all 0.3s ease;
}

.health-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
}

.health-card.full-width {
  grid-column: 1 / -1;
}

.health-card-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.health-card-header svg {
  color: #f59e0b;
}

.health-card-header h4 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: #92400e;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.health-card-content {
  margin: 0;
  font-size: 0.95rem;
  color: #78350f;
  line-height: 1.6;
  font-weight: 500;
}

.no-health-info {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  border: 2px solid #10b981;
  border-radius: var(--radius-md);
  color: #065f46;
}

.no-health-info svg {
  color: #10b981;
}

.no-health-info p {
  margin: 0;
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
}

.authorized-persons-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1rem;
}

.authorized-person-card {
  display: flex;
  gap: 1rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #f0f9f9 0%, #e0f2f2 100%);
  border: 2px solid #5A9C9C;
  border-radius: var(--radius-md);
  transition: all 0.3s ease;
}

.authorized-person-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(90, 156, 156, 0.2);
}

.authorized-person-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5A9C9C 0%, #4a8c8c 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(90, 156, 156, 0.3);
}

.authorized-person-info {
  flex: 1;
}

.authorized-person-info h4 {
  margin: 0 0 0.5rem 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2937;
}

.authorized-person-details {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.authorized-person-details span {
  font-size: 0.9rem;
  color: #475569;
}

.authorized-person-details strong {
  color: #2c5f6f;
  margin-right: 0.25rem;
}

@media (max-width: 768px) {
  .child-details-modal {
    max-width: 95%;
    margin: 1rem;
  }

  .child-modal-avatar {
    width: 50px;
    height: 50px;
  }

  .child-info-grid {
    grid-template-columns: 1fr;
  }

  .child-health-grid {
    grid-template-columns: 1fr;
  }

  .authorized-persons-grid {
    grid-template-columns: 1fr;
  }

  .child-info-section {
    padding: 1rem;
  }

  .modal-header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.75rem;
  }
}

@media (max-width: 480px) {
  .child-details-modal {
    max-width: 100%;
    margin: 0;
    border-radius: 0;
    max-height: 100vh;
  }

  .child-modal-overlay {
    padding: 0;
  }

  .child-info-value {
    font-size: 0.9rem;
    padding: 0.5rem;
  }

  .health-card,
  .authorized-person-card {
    padding: 1rem;
  }

  .child-section-header h3 {
    font-size: 1.1rem;
  }
}

.child-details-modal::-webkit-scrollbar {
  width: 8px;
}

.child-details-modal::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.child-details-modal::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #5A9C9C 0%, #4a8c8c 100%);
  border-radius: 4px;
}

.child-details-modal::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #4a8c8c 0%, #3a7c7c 100%);
}

@keyframes slideInFromBottom {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.child-details-modal {
  animation: slideInFromBottom 0.3s ease-out;
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-20px); }
}

.admin-header::after {
  content: '';
  position: absolute;
  bottom: -30%;
  left: -5%;
  width: 250px;
  height: 250px;
  background: radial-gradient(circle, rgba(255, 255, 255, 0.08) 0%, transparent 70%);
  border-radius: 50%;
}

.header-content {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.5rem;
}

.header-left {
  flex: 1;
  min-width: 300px;
}

.admin-title {
  font-size: 2.8rem;
  margin: 0 0 0.75rem 0;
  font-weight: 800;
  letter-spacing: -1px;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.admin-subtitle {
  font-size: 1.15rem;
  margin: 0;
  opacity: 0.95;
  font-weight: 400;
  letter-spacing: 0.3px;
}

.header-right {
  display: flex;
  gap: 1rem;
}

.header-action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: var(--radius-md);
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.header-action-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dashboard-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.stat-card {
  background: white;
  padding: 2rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.stat-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: var(--secondary-gradient);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.3s ease;
}

.stat-card:hover::before {
  transform: scaleX(1);
}

.stat-card:hover {
  transform: translateY(-8px);
  box-shadow: var(--shadow-lg);
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.25rem;
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e6f4f4 0%, #d1e9e9 100%);
  color: #2c5f6f;
  box-shadow: 0 4px 12px rgba(44, 95, 111, 0.15);
}

.stat-content {
  flex: 1;
}

.stat-label {
  font-size: 0.9rem;
  color: #64748b;
  margin: 0 0 0.75rem 0;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.stat-value {
  font-size: 2.75rem;
  font-weight: 800;
  color: #0f172a;
  margin: 0 0 0.5rem 0;
  line-height: 1;
  letter-spacing: -1px;
}

.stat-trend {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  margin-top: 0.5rem;
}

.stat-trend.positive {
  color: #059669;
}

.stat-trend.neutral {
  color: #64748b;
}

.stat-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.4rem 0.9rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 700;
  margin-top: 0.75rem;
  letter-spacing: 0.3px;
}

.stat-badge.total {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.15);
}

.stat-badge.pendente {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
  box-shadow: 0 2px 8px rgba(146, 64, 14, 0.15);
}

.stat-badge.confirmado {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  box-shadow: 0 2px 8px rgba(6, 95, 70, 0.15);
}

.stat-badge.cancelado {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  box-shadow: 0 2px 8px rgba(153, 27, 27, 0.15);
}

.toolbar {
  background: white;
  padding: 1.75rem;
  border-radius: var(--radius-lg);
  margin-bottom: 2rem;
  box-shadow: var(--shadow-md);
  display: flex;
  flex-wrap: wrap;
  gap: 1.25rem;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.toolbar-left {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  flex: 1;
  align-items: center;
}

.search-box {
  position: relative;
  flex: 1;
  min-width: 280px;
  max-width: 450px;
}

.search-icon {
  position: absolute;
  left: 1.25rem;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 0.9rem 1.25rem 0.9rem 3.25rem;
  border: 2px solid #e2e8f0;
  border-radius: var(--radius-md);
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: #f8fafc;
}

.search-input:focus {
  outline: none;
  border-color: #2c5f6f;
  background: white;
  box-shadow: 0 0 0 4px rgba(44, 95, 111, 0.1);
}

.search-input::placeholder {
  color: #94a3b8;
}

.filter-group {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.filter-label {
  font-weight: 600;
  color: #475569;
  font-size: 0.9rem;
  white-space: nowrap;
}

.filter-select {
  padding: 0.75rem 1rem;
  border: 2px solid #e2e8f0;
  border-radius: var(--radius-md);
  font-size: 0.95rem;
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  min-width: 150px;
}

.filter-select:focus {
  outline: none;
  border-color: #2c5f6f;
  background: white;
  box-shadow: 0 0 0 4px rgba(44, 95, 111, 0.1);
}

.toolbar-right {
  display: flex;
  gap: 0.75rem;
}

.export-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.5rem;
  background: var(--secondary-gradient);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(90, 156, 156, 0.3);
}

.export-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(90, 156, 156, 0.4);
}

.tabs-container {
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.tabs {
  display: flex;
  border-bottom: 2px solid #f1f5f9;
  background: #fafbfc;
  padding: 0.5rem 1rem;
  gap: 0.5rem;
}

.tab {
  padding: 1rem 1.75rem;
  background: transparent;
  border: none;
  color: #64748b;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: var(--radius-md);
  font-size: 0.95rem;
  position: relative;
}

.tab::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--primary-gradient);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.tab:hover {
  background: rgba(44, 95, 111, 0.05);
  color: #2c5f6f;
}

.tab.active {
  color: #2c5f6f;
  background: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.tab.active::after {
  transform: scaleX(1);
}

.calendar-view {
  padding: 2rem;
  background: linear-gradient(to bottom, #fafbfc 0%, white 100%);
}

.calendar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 2px solid #f1f5f9;
}

.calendar-nav {
  display: flex;
  gap: 1.5rem;
  align-items: center;
}

.nav-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border: 2px solid #e2e8f0;
  border-radius: var(--radius-md);
  color: #475569;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
}

.nav-btn:hover {
  background: var(--secondary-gradient);
  color: white;
  border-color: transparent;
  transform: scale(1.05);
  box-shadow: var(--shadow-md);
}

.calendar-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.5px;
}

.view-toggle {
  display: flex;
  gap: 0.5rem;
  background: #f8fafc;
  padding: 0.35rem;
  border-radius: var(--radius-md);
  border: 2px solid #e2e8f0;
}

.view-toggle button {
  padding: 0.6rem 1.25rem;
  background: transparent;
  border: none;
  color: #64748b;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: calc(var(--radius-md) - 0.25rem);
  font-size: 0.9rem;
}

.view-toggle button:hover {
  color: #2c5f6f;
}

.view-toggle button.active {
  background: white;
  color: #2c5f6f;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1rem;
  margin-top: 1.5rem;
}

.calendar-weekday {
  text-align: center;
  font-weight: 700;
  color: #475569;
  padding: 1rem 0;
  font-size: 0.85rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  background: #f8fafc;
  border-radius: var(--radius-sm);
}

.calendar-day {
  background: white;
  border: 2px solid #f1f5f9;
  border-radius: var(--radius-md);
  padding: 1rem 0.5rem;
  min-height: 140px;
  max-height: 140px;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
}

.calendar-day:hover {
  border-color: #cbd5e1;
  box-shadow: var(--shadow-md);
  transform: translateY(-2px);
}

.calendar-day.other-month {
  opacity: 0.4;
  background: #fafbfc;
}

.calendar-day.today {
  border-color: #2c5f6f;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  box-shadow: 0 0 0 2px rgba(44, 95, 111, 0.1);
}

.day-number {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 0.5rem;
  display: block;
  flex-shrink: 0;
}

.calendar-day.today .day-number {
  color: #2c5f6f;
}

.day-events {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  overflow-y: auto;
  max-height: calc(140px - 2rem);
  min-height: 0;
}

.day-events::-webkit-scrollbar {
  width: 4px;
}

.day-events::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 2px;
}

.day-events::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.day-events::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.day-event {
  font-size: 0.7rem;
  padding: 0.35rem 0.5rem;
  border-radius: var(--radius-sm);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  transition: all 0.2s ease;
  cursor: pointer;
  line-height: 1.2;
  flex-shrink: 0;
  min-height: 24px;
}

.day-event:hover {
  transform: translateX(3px);
  box-shadow: var(--shadow-sm);
}

.day-event.pendente {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
  border-left: 3px solid #d97706;
}

.day-event.confirmado {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border-left: 3px solid #059669;
}

.day-event.cancelado {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border-left: 3px solid #dc2626;
}

.day-event.evento {
  background: linear-gradient(135deg, #e9d5ff 0%, #d8b4fe 100%);
  color: #6b21a8;
  border-left: 3px solid #7c3aed;
}

.day-events.has-more-events::after {
  content: "...";
  text-align: center;
  color: #64748b;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.25rem;
  background: #f8fafc;
  border-radius: var(--radius-sm);
  margin-top: 0.25rem;
}

.bookings-list {
  padding: 2rem;
  background: linear-gradient(to bottom, #fafbfc 0%, white 100%);
}

.bookings-grid {
  display: grid;
  gap: 1.25rem;
}

.booking-item {
  background: white;
  border: 2px solid #f1f5f9;
  border-radius: var(--radius-lg);
  padding: 1.75rem;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.booking-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 5px;
  background: var(--secondary-gradient);
  transition: width 0.3s ease;
}

.booking-item:hover {
  border-color: #cbd5e1;
  box-shadow: var(--shadow-lg);
  transform: translateY(-4px);
}

.booking-item:hover::before {
  width: 8px;
}

.booking-item.event-reservation {
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.05) 0%, rgba(124, 58, 237, 0.02) 100%);
  border-color: rgba(139, 92, 246, 0.2);
}

.booking-item.event-reservation::before {
  background: var(--purple-gradient);
}

.day-event.multi-day {
  border-left-width: 4px;
}

.day-event.evento.multi-day {
  background: linear-gradient(135deg, #e9d5ff 0%, #d8b4fe 100%);
  color: #6b21a8;
  border-left-color: #7c3aed;
}

.day-event.evento.multi-day[title*="selecionados"] {
  background: linear-gradient(135deg, #c7d2fe 0%, #a5b4fc 100%);
  color: #3730a3;
  border-left-color: #4f46e5;
}

.day-event.evento.multi-day[title*="multi-dia"] {
  background: linear-gradient(135deg, #bae6fd 0%, #7dd3fc 100%);
  color: #0c4a6e;
  border-left-color: #0ea5e9;
}

.booking-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  gap: 1rem;
}

.booking-title-section {
  flex: 1;
}

.booking-service {
  font-size: 1.35rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.5rem 0;
  letter-spacing: -0.3px;
}

.booking-date-time {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  color: #64748b;
  font-size: 0.95rem;
  flex-wrap: wrap;
}

.booking-date-time > div {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.65rem 1.25rem;
  border-radius: 50px;
  font-size: 0.85rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: var(--shadow-sm);
  transition: all 0.3s ease;
}

.status-badge:hover {
  transform: scale(1.05);
  box-shadow: var(--shadow-md);
}

.status-badge.pendente {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
  border: 2px solid #f59e0b;
}

.status-badge.confirmado {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border: 2px solid #10b981;
}

.status-badge.cancelado {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border: 2px solid #ef4444;
}

.booking-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 0.875rem;
  padding: 1.5rem;
  background: #f8fafc;
  border-radius: var(--radius-md);
  margin-bottom: 1.25rem;
}

.booking-detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  min-width: 0;
}

.detail-label {
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.detail-value {
  font-size: 1rem;
  color: #0f172a;
  font-weight: 600;
}

.detail-value.multiline {
  white-space: pre-wrap;
  line-height: 1.6;
}

.booking-actions {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  box-shadow: var(--shadow-sm);
}

.action-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.action-btn.view {
  background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
  color: #075985;
}

.action-btn.confirm {
  background: var(--success-gradient);
  color: white;
}

.action-btn.cancel {
  background: var(--danger-gradient);
  color: white;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.75);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal {
  background: white;
  border-radius: var(--radius-xl);
  max-width: 800px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 2.5rem;
  border-bottom: 2px solid #f1f5f9;
  background: linear-gradient(135deg, #fafbfc 0%, white 100%);
  position: sticky;
  top: 0;
  z-index: 10;
}

.modal-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.5px;
}

.modal-close-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8fafc;
  border: 2px solid #e2e8f0;
  border-radius: var(--radius-md);
  color: #64748b;
  cursor: pointer;
  transition: all 0.3s ease;
}

.modal-close-btn:hover {
  background: #fee2e2;
  border-color: #fecaca;
  color: #991b1b;
  transform: rotate(90deg);
}

.modal-body {
  padding: 2.5rem;
}

.booking-detail-section {
  margin-bottom: 2.5rem;
}

.booking-detail-section:last-child {
  margin-bottom: 0;
}

.detail-title {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-size: 1.25rem;
  font-weight: 700;
  color: #0f172a;
  margin-bottom: 1.25rem;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid #f1f5f9;
}

.detail-title-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #e6f4f4 0%, #d1e9e9 100%);
  color: #2c5f6f;
  border-radius: var(--radius-md);
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
}

.detail-item {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1.25rem;
  background: #f8fafc;
  border-radius: var(--radius-md);
  border: 1px solid #e2e8f0;
}

.children-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.child-tag {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.25rem;
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.9rem;
  border: 2px solid #93c5fd;
  box-shadow: var(--shadow-sm);
}

.selected-days-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1rem;
}

.selected-day-item {
  background: linear-gradient(135deg, #e6f4f4 0%, #d1e9e9 100%);
  color: #2c5f6f;
  padding: 0.75rem 1.25rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 700;
  border: 2px solid #5A9C9C;
  box-shadow: var(--shadow-sm);
}

.status-badge-container {
  display: flex;
  justify-content: center;
  padding: 1.5rem;
}

.modal-actions {
  display: flex;
  gap: 1rem;
  padding: 2rem 2.5rem;
  border-top: 2px solid #f1f5f9;
  background: #fafbfc;
  justify-content: flex-end;
  flex-wrap: wrap;
  position: sticky;
  bottom: 0;
}

.btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.9rem 1.75rem;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 1rem;
  box-shadow: var(--shadow-sm);
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

.btn-confirm {
  background: var(--success-gradient);
  color: white;
}

.btn-cancel {
  background: var(--danger-gradient);
  color: white;
}

.btn-close {
  background: white;
  color: #475569;
  border: 2px solid #e2e8f0;
}

.btn-close:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.empty-state {
  text-align: center;
  padding: 4rem 2rem;
}

.empty-state-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 1.5rem;
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

.empty-state-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #475569;
  margin: 0 0 0.75rem 0;
}

.empty-state-message {
  font-size: 1rem;
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

@media (max-width: 1024px) {
  .admin-container {
    padding: 0 1rem;
  }
  
  .dashboard-stats {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  
  .calendar-grid {
    gap: 0.75rem;
  }
  
  .calendar-day {
    min-height: 120px;
    padding: 1rem 0.5rem;
  }
}

@media (max-width: 768px) {
  .admin-header {
    padding: 2rem 1.5rem;
  }
  
  .admin-title {
    font-size: 2rem;
  }
  
  .header-content {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .header-right {
    width: 100%;
  }
  
  .header-action-btn {
    flex: 1;
    justify-content: center;
  }
  
  .dashboard-stats {
    grid-template-columns: 1fr;
  }
  
  .toolbar {
    flex-direction: column;
    align-items: stretch;
  }
  
  .toolbar-left,
  .toolbar-right {
    width: 100%;
  }
  
  .search-box {
    max-width: none;
  }
  
  .filter-group {
    flex-direction: column;
    align-items: stretch;
  }
  
  .filter-select {
    width: 100%;
  }
  
  .tabs {
    overflow-x: auto;
    padding-bottom: 0.75rem;
  }
  
  .tab {
    white-space: nowrap;
  }
  
  .calendar-grid {
    grid-template-columns: repeat(7, minmax(80px, 1fr));
    gap: 0.5rem;
  }
  
  .calendar-day {
    min-height: 100px;
    padding: 0.75rem 0.35rem;
  }
  
  .day-number {
    font-size: 0.95rem;
    margin-bottom: 0.5rem;
  }
  
  .day-event {
    font-size: 0.7rem;
    padding: 0.4rem 0.5rem;
  }
  
  .booking-details {
    grid-template-columns: 1fr;
  }
  
  .modal {
    margin: 0.5rem;
    max-height: 95vh;
  }
  
  .modal-header,
  .modal-body,
  .modal-actions {
    padding: 1.5rem;
  }
  
  .detail-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .calendar-grid {
    grid-template-columns: repeat(7, minmax(60px, 1fr));
    gap: 0.35rem;
  }
  
  .calendar-weekday {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }
  
  .calendar-day {
    min-height: 80px;
    padding: 0.5rem 0.25rem;
  }
  
  .day-number {
    font-size: 0.85rem;
  }
  
  .day-events {
    gap: 0.35rem;
  }
  
  .day-event {
    font-size: 0.65rem;
    padding: 0.35rem;
  }
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb {
  background: linear-gradient(135deg, #cbd5e1 0%, #94a3b8 100%);
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
}

.day-bookings-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 60vh;
  overflow-y: auto;
  padding: 0.5rem;
}

.day-booking-card {
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: var(--radius-md);
  padding: 1.25rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.day-booking-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
  border-color: #2c5f6f;
}

.day-booking-card.evento {
  border-left: 4px solid #8B5CF6;
}

.day-booking-card.confirmado {
  border-left: 4px solid #10b981;
}

.day-booking-card.pendente {
  border-left: 4px solid #f59e0b;
}

.day-booking-card.cancelado {
  border-left: 4px solid #ef4444;
}

.booking-card-header {
  display: flex;
  justify-content: space-between;
  align-items: start;
  margin-bottom: 0.75rem;
}

.booking-card-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.booking-card-time {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  font-size: 0.9rem;
  color: #64748b;
  font-weight: 600;
}

.booking-card-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.booking-card-detail-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: #475569;
}

.booking-card-detail-item svg {
  color: #2c5f6f;
  flex-shrink: 0;
}

.day-bookings-empty {
  text-align: center;
  padding: 3rem 1rem;
  color: #64748b;
}

.day-bookings-empty svg {
  margin-bottom: 1rem;
  opacity: 0.5;
}

.participants-table {
  width: 100%;
  margin-top: 1rem;
}

.participants-data-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

.participants-data-table thead {
  background: linear-gradient(135deg, #5A9C9C 0%, #4a8c8c 100%);
}

.participants-data-table thead th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.9rem;
  color: white;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.participants-data-table tbody tr {
  border-bottom: 1px solid #e5e7eb;
  transition: background-color 0.2s;
}

.participants-data-table tbody tr:last-child {
  border-bottom: none;
}

.participants-data-table tbody tr:hover {
  background-color: #f8fafc;
}

.participants-data-table tbody td {
  padding: 1rem;
  font-size: 0.95rem;
  color: #334155;
}

.participants-data-table tbody td:first-child {
  font-weight: 600;
  color: #5A9C9C;
  width: 50px;
  text-align: center;
}

.participants-summary {
  margin-top: 1rem;
  padding: 0.75rem 1rem;
  background: linear-gradient(135deg, #f0f9f9 0%, #e0f2f2 100%);
  border-radius: var(--radius-sm);
  text-align: right;
  font-size: 0.95rem;
  color: #2c5f6f;
}

.participants-summary strong {
  font-weight: 700;
  margin-right: 0.5rem;
}

.presence-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
  accent-color: #5A9C9C;
  transition: transform 0.2s;
}

.presence-checkbox:hover {
  transform: scale(1.1);
}

.participants-data-table tbody td:last-child {
  text-align: center;
}

.no-participants-warning {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.25rem;
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  border: 2px solid #f59e0b;
  border-radius: var(--radius-md);
  color: #92400e;
  font-weight: 500;
  margin-top: 1rem;
}

.no-participants-warning svg {
  flex-shrink: 0;
  color: #f59e0b;
}

@media (max-width: 768px) {
  .participants-data-table {
    font-size: 0.85rem;
  }
  
  .participants-data-table thead th {
    padding: 0.75rem 0.5rem;
    font-size: 0.8rem;
  }
  
  .participants-data-table tbody td {
    padding: 0.75rem 0.5rem;
    font-size: 0.85rem;
  }
  
  .participants-summary {
    font-size: 0.85rem;
    padding: 0.5rem 0.75rem;
  }
}

@media (max-width: 480px) {
  .participants-data-table {
    display: block;
    overflow-x: auto;
  }
  
  .participants-data-table thead {
    display: none;
  }
  
  .participants-data-table tbody {
    display: block;
  }
  
  .participants-data-table tbody tr {
    display: block;
    margin-bottom: 1rem;
    border: 1px solid #e5e7eb;
    border-radius: var(--radius-sm);
    padding: 0.75rem;
  }
  
  .participants-data-table tbody td {
    display: block;
    padding: 0.5rem 0;
    border-bottom: none;
  }
  
  .participants-data-table tbody td:first-child {
    font-size: 1.1rem;
    color: #5A9C9C;
    font-weight: 700;
    text-align: left;
    margin-bottom: 0.5rem;
  }
  
  .participants-data-table tbody td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #64748b;
    display: inline-block;
    width: 120px;
    margin-right: 0.5rem;
  }
  
  .participants-data-table tbody td:first-child::before {
    content: "Participante #";
  }
}

.booking-admin-actions {
  display: flex;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 2px solid #e2e8f0;
  margin-top: 1rem;
}

.btn-edit {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-edit:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.3);
}

.btn-cancel-booking {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 0.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel-booking:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

.booking-card-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  gap: 0.375rem;
}

.edit-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
}

.edit-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
}

.cancel-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
}

.cancel-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
}
`;

export default function AdminDashboardPage() {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [eventReservations, setEventReservations] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [selectedEventReservation, setSelectedEventReservation] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showEventModal, setShowEventModal] = useState(false);
  const [activeTab, setActiveTab] = useState('calendar');
  const [filterStatus, setFilterStatus] = useState('Todos');
  const [searchTerm, setSearchTerm] = useState('');
  const [currentDate, setCurrentDate] = useState(new Date());
  const [showDayBookingsModal, setShowDayBookingsModal] = useState(false);
  const [selectedDayBookings, setSelectedDayBookings] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const { alertProps, showSuccess, showError } = useCustomAlert();
  const [showChildModal, setShowChildModal] = useState(false);
  const [selectedChild, setSelectedChild] = useState(null);
  const [calendarData, setCalendarData] = useState(null);
  const [stats, setStats] = useState(null);
  const [showCreateBookingModal, setShowCreateBookingModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [bookingToEdit, setBookingToEdit] = useState(null);
  const [showEditEventModal, setShowEditEventModal] = useState(false);
  const [eventToEdit, setEventToEdit] = useState(null);
  const [selectedDateForBooking, setSelectedDateForBooking] = useState(null);

  const [loadingDayDetails, setLoadingDayDetails] = useState(false);

  useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.textContent = styles;
    document.head.appendChild(styleElement);
    return () => document.head.removeChild(styleElement);
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await authService.getUser(); 
        
        if (!user) {
          navigate('/');
          return;
        }
        
        if (user.isAdmin !== true) {
          showError('Acesso negado. Esta página é apenas para administradores.');
          navigate('/');
          return;
        }
        
        await fetchData();
      } catch (error) {
        console.error('Erro na verificação de autenticação:', error);
        navigate('/');
      }
    };
    checkAuth();
  }, [navigate]); 

const fetchData = async () => {
  try {
    setLoading(true);
    const [calendarData, stats] = await Promise.all([
      eventService.getCalendarData(),
      eventService.getQuickStats()
    ]);

    console.log(calendarData);
    
    const processedBookings = [];
    const processedEvents = [];
    
    if (calendarData?.bookingsByDate) {
      calendarData.bookingsByDate.forEach(dayData => {
        processedBookings.push({
          id: `cal-booking-${dayData.date}`,
          dataHora: new Date(dayData.date),
          status: 'Confirmado',
          servicoNome: `${dayData.bookingsCount} marcações`,
          userName: dayData.userName,
          userEmail: dayData.userEmail,
          isCalendarData: true,
          user: { nome: dayData.userName, email: dayData.userEmail },
          confirmedCount: dayData.confirmedCount,
          pendingCount: dayData.pendingCount,
          totalCount: dayData.bookingsCount
        });
      });
    }

    
    if (calendarData?.eventsByDate) {
      calendarData.eventsByDate.forEach(dayData => {
        dayData.events.forEach(event => {
            processedEvents.push({
              id: event.reservationId,
              reservationId: event.reservationId,
              eventId: event.eventId,
              eventTitle: event.title,
              eventStartDate: new Date(dayData.date),
              eventEndDate: event.eventEndDate ? new Date(event.eventEndDate) : null,
              numberOfParticipants: event.participantsCount,
              userName: event.userName,
              userEmail: event.userEmail,
              userPhone: event.userPhone,
              status: event.status,
              totalPrice: event.totalPrice,
              timeSlotReservations: event.timeSlotReservations || [],
              paymentType: event.paymentType || 'deposit',
              participants: (event.participants || []).filter(p => p && p.nome),
              selectedDays: event.selectedDays,
              isEventReservation: true,
              isCalendarData: true
            });
        });
      });
    }    
    setBookings(processedBookings);
    console.log(processedBookings)
    setEventReservations(processedEvents);
    setCalendarData(calendarData);
    console.log(calendarData)
    setStats(stats);
    setLoading(false);
    
  } catch (error) {
    console.error('âŒ Erro ao carregar dados:', error);
    showError('Erro ao carregar os dados. Por favor, tente novamente.');
    setLoading(false);
  }
};

  const handleCacifoChange = async (participantId, numeroCacifo) => {
    try {
      await bookingService.updateParticipantCacifo(selectedBooking.id, participantId, numeroCacifo);
      
      setSelectedBooking(prev => ({
        ...prev,
        partyParticipants: prev.partyParticipants.map(p => 
          p.id === participantId ? { ...p, cacifo: numeroCacifo } : p
        )
      }));
    } catch (error) {
      console.error('Erro ao atualizar cacifo:', error);
      showError('Erro ao atualizar número do cacifo');
    }
  };

  const calculateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    
    return age;
  };

  const parsePessoasAutorizadas = (pessoasStr) => {
    if (!pessoasStr) return [];
    
    try {
      const pessoas = JSON.parse(pessoasStr);
      return Array.isArray(pessoas) ? pessoas : [];
    } catch {
      return [];
    }
  };

  const handleTogglePresence = async (participantId, isPresent) => {
    try {
      await bookingService.updateParticipantPresence(selectedBooking.id, participantId, isPresent);
      
      setSelectedBooking(prev => ({
        ...prev,
        partyParticipants: prev.partyParticipants.map(p => 
          p.id === participantId ? { ...p, isPresent } : p
        )
      }));
      
      showSuccess('Presença atualizada com sucesso');
    } catch (error) {
      console.error('Erro ao atualizar presença:', error);
      showError('Erro ao atualizar presença');
    }
  };


  const handleCancelBooking = async (booking) => {
    if (!window.confirm(`Tem certeza que deseja cancelar a reserva de ${booking.servicoNome}?`)) {
      return;
    }

    try {
      await bookingService.adminCancelBooking(booking.id);
      setShowModal(false);
      setShowDayBookingsModal(false);
    } catch (error) {
    }
  };

  const handleEditBooking = (booking) => {
    setBookingToEdit(booking);
    setShowEditModal(true);
    setShowModal(false);
    setShowDayBookingsModal(false);
  };

  const handleEditSuccess = async () => {
    try {
      const allBookings = await bookingService.getAllBookings();
    } catch (error) {
      console.error('Erro ao recarregar bookings:', error);
    }
  };

  const handleCancelEventReservation = async (eventReservation) => {
    if (!window.confirm(`Tem certeza que deseja cancelar a reserva do evento ${eventReservation.eventTitle}?`)) {
      return;
    }

    try {
      await eventService.adminCancelEventReservation(eventReservation.reservationId || eventReservation.id);
      
      setShowEventModal(false);
      setShowModal(false);
      setShowDayBookingsModal(false);
    } catch (error) {
    }
  };

  const handleEditEventReservation = (eventReservation) => {
    setEventToEdit(eventReservation);
    setShowEditEventModal(true);
    setShowEventModal(false);
    setShowDayBookingsModal(false);
  };

  const handleEditEventSuccess = async () => {
    try {
      const [calendarData, stats] = await Promise.all([
        eventService.getCalendarData(),
        eventService.getStats()
      ]);
      setCalendarData(calendarData);
    } catch (error) {
      console.error('Erro ao recarregar dados do calendário:', error);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString('pt-PT', { hour: '2-digit', minute: '2-digit' });
  };

  const formatSelectedDays = (selectedDays) => {
    if (!selectedDays || selectedDays.length === 0) {
      return 'Nenhum dia selecionado';
    }
    
    try {
      const daysArray = typeof selectedDays === 'string' 
        ? JSON.parse(selectedDays) 
        : selectedDays;
      
      if (!Array.isArray(daysArray)) {
        return 'Formato de dias inválido';
      }
      
      return daysArray.map(day => {
        const date = new Date(day);
        return date.toLocaleDateString('pt-PT', { 
          day: '2-digit', 
          month: '2-digit', 
          year: 'numeric' 
        });
      }).join(', ');
    } catch {
      return 'Erro ao formatar dias';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'Pendente':
        return <HourglassIcon size={16} />;
      case 'Confirmado':
        return <CheckCircle size={16} />;
      case 'Cancelado':
        return <XOctagon size={16} />;
      default:
        return <AlertCircle size={16} />;
    }
  };

  const filteredBookings = [...bookings, ...eventReservations].filter(booking => {
    
    const matchesStatus = filterStatus === 'Todos' || booking.status === filterStatus;
    const searchLower = searchTerm.toLowerCase();
    
    const serviceName = booking.isEventReservation ? booking.eventTitle : booking.servicoNome;
    
    const matchesSearch = 
      serviceName?.toLowerCase().includes(searchLower) ||
      booking.userName?.toLowerCase().includes(searchLower) ||
      booking.userEmail?.toLowerCase().includes(searchLower);
    return matchesStatus && matchesSearch;
  });

  const getDaysInMonth = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();
    
    const days = [];
    const prevMonthLastDay = new Date(year, month, 0).getDate();
    
    for (let i = startingDayOfWeek - 1; i >= 0; i--) {
      days.push({
        date: new Date(year, month - 1, prevMonthLastDay - i),
        isCurrentMonth: false
      });
    }
    
    for (let i = 1; i <= daysInMonth; i++) {
      days.push({
        date: new Date(year, month, i),
        isCurrentMonth: true
      });
    }
    
    const remainingDays = 42 - days.length;
    for (let i = 1; i <= remainingDays; i++) {
      days.push({
        date: new Date(year, month + 1, i),
        isCurrentMonth: false
      });
    }
    
    return days;
  };
  const getEventType = (reservation) => {
    if (!reservation.isEventReservation) return 'booking';
    
    const hasSelectedDays = reservation.selectedDays && 
                          Array.isArray(reservation.selectedDays) && 
                          reservation.selectedDays.length > 0;
    
    if (hasSelectedDays) {
      return 'multi-day-selected';
    }
    
    if (reservation.eventType === 'multi' && reservation.eventEndDate) {
      return 'multi-day-range';
    }
    
    return 'single-day';
  };

  const getBookingsForDate = (date) => {
  const bookingsForDate = [];
  const seenEventReservations = new Set();
  
  filteredBookings.forEach(booking => {
    try {
      if (booking.isEventReservation) {
        const reservationKey = `${booking.id}_${date.toISOString().split('T')[0]}`;
        if (seenEventReservations.has(reservationKey)) {
          return;
        }
        
        let occursOnDate = false;
        
        if (booking.selectedDays && booking.selectedDays.length > 0) {
          try {
            const selectedDays = typeof booking.selectedDays === 'string' 
              ? JSON.parse(booking.selectedDays) 
              : booking.selectedDays;
            
            if (Array.isArray(selectedDays) && selectedDays.length > 0) {
              const dateString = date.toISOString().split('T')[0]; 
              occursOnDate = selectedDays.some(day => {
                try {
                  const selectedDate = new Date(day).toISOString().split('T')[0];
                  return selectedDate === dateString;
                } catch {
                  return false;
                }
              });
            }
          } catch (error) {
            console.error('Erro ao processar selectedDays:', error, booking.selectedDays);
          }
        }
        
        if (!occursOnDate && booking.timeSlotReservations && booking.timeSlotReservations.length > 0) {
          const dateString = date.toISOString().split('T')[0];
          occursOnDate = booking.timeSlotReservations.some(ts => {
            if (ts.specificDate) {
              const tsDate = new Date(ts.specificDate).toISOString().split('T')[0];
              return tsDate === dateString;
            }
            return false;
          });
        }
        
        if (!occursOnDate) {
          const bookingDate = new Date(booking.eventStartDate);
          occursOnDate = bookingDate.toDateString() === date.toDateString();
        }
        
        if (occursOnDate) {
          seenEventReservations.add(reservationKey);
          bookingsForDate.push(booking);
        }
      } else {
        const bookingDate = new Date(booking.dataHora);
        if (bookingDate.toDateString() === date.toDateString()) {
          bookingsForDate.push(booking);
        }
      }
    } catch (error) {
      console.error('Erro ao processar data do booking:', error, booking);
    }
  });
  
  return bookingsForDate;
};

  const changeMonth = (direction) => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + direction, 1));
  };

  const isToday = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };


  const handleDayClick = async (date) => {
  try {
    setLoadingDayDetails(true);    
    const dayDetails = await eventService.getDayDetails(date);    
    const filteredBookings = dayDetails.bookings;
    const filteredEvents = dayDetails.eventReservations;
    
    setSelectedDate(date);
    setSelectedDayBookings([
      ...filteredBookings,
      ...filteredEvents.map(r => ({ ...r, isEventReservation: true }))
    ]);
    setShowDayBookingsModal(true);
  } catch (error) {
    console.error('Erro ao carregar detalhes do dia:', error);
    showError('Erro ao carregar detalhes do dia');
  } finally {
    setLoadingDayDetails(false);
  }
};

  if (loading) {
    return (
      <div className="admin-dashboard">
        <div className="admin-container">
          <div style={{ textAlign: 'center', padding: '4rem' }}>
            <Activity size={48} color="#2c5f6f" style={{ animation: 'spin 1s linear infinite' }} />
            <p style={{ marginTop: '1rem', color: '#64748b', fontSize: '1.1rem', fontWeight: '600' }}>A carregar dados...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="admin-dashboard">
        <div className="admin-container">
          <div className="admin-header">
            <div className="header-content">
              <div className="header-left">
                <h1 className="admin-title">Painel Administrativo</h1>
                <p className="admin-subtitle">Gestão completa de agendamentos e eventos</p>
              </div>
              <div className="header-right">
                <button className="header-action-btn" onClick={() => navigate('/admin/analytics')}>
                  <BarChart3 size={20} />
                  Análise
                </button>
                <button className="header-action-btn" onClick={() => navigate('/admin/eventos')}>
                  <Calendar size={20} />
                  Gerir Eventos
                </button>
              </div>
            </div>
          </div>

          <div className="toolbar">
            <div className="toolbar-left">
              <div className="search-box">
                <Search className="search-icon" size={20} />
                <input
                  type="text"
                  className="search-input"
                  placeholder="Pesquisar por serviço, cliente ou email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="toolbar-right">
              <button className="export-btn">
                <Download size={20} />
                Exportar
              </button>
            </div>
          </div>

          <div className="tabs-container">
            <div className="tabs">
              <button
                className={`tab ${activeTab === 'calendar' ? 'active' : ''}`}
                onClick={() => setActiveTab('calendar')}
              >
                <Calendar size={20} />
                Calendário
              </button>
              {/*
              <button
                className={`tab ${activeTab === 'list' ? 'active' : ''}`}
                onClick={() => setActiveTab('list')}
              >
                <Users size={20} />
                Lista de Agendamentos
              </button>
              <button
                className={`tab ${activeTab === 'events' ? 'active' : ''}`}
                onClick={() => setActiveTab('events')}
              >
                <PieChart size={20} />
                Reservas de Eventos
              </button>
               */}
            </div>

            {activeTab === 'calendar' && (
  <div className="calendar-view">
    <div className="calendar-header">
      <div className="calendar-nav">
        <button className="nav-btn" onClick={() => changeMonth(-1)}>
          <ChevronLeft size={20} />
        </button>
        <h2 className="calendar-title">
          {currentDate.toLocaleDateString('pt-PT', { month: 'long', year: 'numeric' })}
        </h2>
        <button className="nav-btn" onClick={() => changeMonth(1)}>
          <ChevronRight size={20} />
        </button>
      </div>
    </div>

    <div className="calendar-grid">
      {['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'].map(day => (
        <div key={day} className="calendar-weekday">{day}</div>
      ))}
      {getDaysInMonth(currentDate).map((day, index) => (
        <div
          key={index}
          className={`calendar-day ${!day.isCurrentMonth ? 'other-month' : ''} ${isToday(day.date) ? 'today' : ''}`}
          onClick={(e) => {
            handleDayClick(day.date);
          }}
          style={{ cursor: 'pointer' }}
        >
          <span className="day-number">{day.date.getDate()}</span>
          <div className="day-events">
            {getBookingsForDate(day.date).map((booking, idx) => {
              let timeSlotCountForDay = 0;
              
              if (booking.isEventReservation && booking.timeSlotReservations) {
                const dateString = day.date.toISOString().split('T')[0];
                timeSlotCountForDay = booking.timeSlotReservations.filter(ts => {
                  if (ts.specificDate) {
                    const tsDate = new Date(ts.specificDate).toISOString().split('T')[0];
                    return tsDate === dateString;
                  }
                  return false;
                }).length;
              }
              
              const eventType = getEventType(booking);
              const isMultiDaySelected = eventType === 'multi-day-selected';
              const isMultiDayRange = eventType === 'multi-day-range';
              const isMultiDay = isMultiDaySelected || isMultiDayRange;
              
              return (
                <div
                  key={idx}
                  className={`day-event ${booking.isEventReservation ? 'evento' : booking.status?.toLowerCase()} ${isMultiDay ? 'multi-day' : ''}`}
                  title={`${booking.isEventReservation ? booking.eventTitle : booking.servicoNome}${
                    timeSlotCountForDay > 0 ? ` (${timeSlotCountForDay} time slots)` : 
                    isMultiDaySelected ? ` (${booking.selectedDays.length} dias)` : 
                    isMultiDayRange ? ' (evento multi-dia)' : ''
                  }`}
                  style={{ pointerEvents: 'none' }}
                >
                  <span style={{marginLeft: '2px', flex: 1}}>
                    {booking.isEventReservation 
                      ? booking.eventTitle.substring(0, 8) + (booking.eventTitle.length > 8 ? '...' : '')
                      : booking.servicoNome.substring(0, 8) + (booking.servicoNome.length > 8 ? '...' : '')
                    }
                    {timeSlotCountForDay > 0 && ` (${timeSlotCountForDay})`}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  </div>
)}

            {activeTab === 'list' && (
              <div className="bookings-list">
                {filteredBookings.filter(b => !b.isEventReservation).length === 0 ? (
                  <div className="empty-state">
                    <div className="empty-state-icon">
                      <Calendar size={40} />
                    </div>
                    <h3 className="empty-state-title">Nenhum agendamento encontrado</h3>
                    <p className="empty-state-message">Não existem agendamentos para os filtros selecionados.</p>
                  </div>
                ) : (
                  <div className="bookings-grid">
                    {filteredBookings.filter(b => !b.isEventReservation).map(booking => (
                      <div key={booking.id} className="booking-item">
                        <div className="booking-header">
                          <div className="booking-title-section">
                            <h3 className="booking-service">{booking.servicoNome}</h3>
                            <div className="booking-date-time">
                              <div>
                                <Calendar size={16} />
                                {formatDate(booking.dataHora)}
                              </div>
                              <div>
                                <Clock size={16} />
                                {formatTime(booking.dataHora)}
                              </div>
                            </div>
                          </div>
                          <span className={`status-badge ${booking.status.toLowerCase()}`}>
                            {getStatusIcon(booking.status)}
                            {booking.status}
                          </span>
                        </div>

                        <div className="booking-details">
                          <div className="booking-details-row">
                            <div className="booking-detail-item">
                              <span className="detail-label">Cliente</span>
                              <span className="detail-value">{booking.user?.nome || 'N/A'}</span>
                            </div>
                            <div className="booking-detail-item">
                              <span className="detail-label">Email</span>
                              <span className="detail-value" style={{fontSize: '0.85rem'}}>{booking.user?.email || 'N/A'}</span>
                            </div>
                            {booking.userPhone && (
                              <div className="booking-detail-item">
                                <span className="detail-label">Telefone</span>
                                <span className="detail-value">{booking.userPhone}</span>
                              </div>
                            )}
                          </div>

                          <div className="booking-details-row">
                            <div className="booking-detail-item">
                              <span className="detail-label">Preço Total</span>
                              <span className="detail-value" style={{fontSize: '1.1rem', color: '#0f172a'}}>{booking.preco}</span>
                            </div>
                            
                            {booking.paymentType && (
                              <>
                                <div className="booking-detail-item">
                                  <span className="detail-label">Tipo de Pagamento</span>
                                  <span className="detail-value" style={{
                                    color: booking.paymentType === 'full' ? '#10b981' : '#f59e0b',
                                    fontWeight: 600,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                  }}>
                                    {booking.paymentType === 'full' ? '' : 'ðŸ’°'}
                                    {booking.paymentType === 'full' ? 'Pago Totalmente' : 'Caução (50%)'}
                                  </span>
                                </div>

                                {booking.paymentType === 'deposit' && (
                                  <>
                                    <div className="booking-detail-item">
                                      <span className="detail-label">Pago</span>
                                      <span className="detail-value" style={{ color: '#10b981', fontWeight: 600 }}>
                                        €{(parseFloat(booking.preco.replace('€','').replace(',','.')) / 2).toFixed(2)}
                                      </span>
                                    </div>
                                    <div className="booking-detail-item">
                                      <span className="detail-label">Falta Pagar</span>
                                      <span className="detail-value" style={{ color: '#f59e0b', fontWeight: 600 }}>
                                        €{(parseFloat(booking.preco.replace('€','').replace(',','.')) / 2).toFixed(2)}
                                      </span>
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        <div className="booking-actions">
                          <button
                            className="action-btn view"
                            onClick={() => {
                              setSelectedBooking(booking);
                              setShowModal(true);
                            }}
                          >
                            <Eye size={18} />
                            Ver Detalhes
                          </button>
                          {booking.status === 'Pendente' && (
                            <>
                              <button
                                className="action-btn confirm"
                                onClick={async () => {
                                  await bookingService.updateBookingStatus(booking.id, 'Confirmado');
                                  await fetchData();
                                }}
                              >
                                <Check size={18} />
                                Confirmar
                              </button>
                              <button
                                className="action-btn cancel"
                                onClick={async () => {
                                  await bookingService.updateBookingStatus(booking.id, 'Cancelado');
                                  await fetchData();
                                }}
                              >
                                <XCircle size={18} />
                                Cancelar
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {activeTab === 'events' && (
              <div className="bookings-list">
                {filteredBookings.filter(b => b.isEventReservation).length === 0 ? (
                  <div className="empty-state">
                    <div className="empty-state-icon">
                      <Calendar size={40} />
                    </div>
                    <h3 className="empty-state-title">Nenhuma reserva de evento encontrada</h3>
                    <p className="empty-state-message">Não existem reservas de eventos para os filtros selecionados.</p>
                  </div>
                ) : (
                  <div className="bookings-grid">
                    {filteredBookings.filter(b => b.isEventReservation).map(reservation => (
                      <div key={reservation.id} className="booking-item event-reservation">
                        <div className="booking-header">
                          <div className="booking-title-section">
                            <h3 className="booking-service">{reservation.eventTitle}</h3>
                            <div className="booking-date-time">
                              <div>
                                <Calendar size={16} />
                                {Array.isArray(reservation.selectedDays) && reservation.selectedDays.length > 0 
                                  ? `${reservation.selectedDays.length} dia(s) selecionado(s)`
                                  : formatDate(reservation.eventStartDate)
                                }
                              </div>
                              {reservation.selectedDays && reservation.selectedDays.length > 0 && (
                                <div title={formatSelectedDays(reservation.selectedDays)}>
                                  <Clock size={16} />
                                  Ver dias
                                </div>
                              )}
                            </div>
                          </div>
                          <span className={`status-badge ${reservation.status.toLowerCase()}`}>
                            {getStatusIcon(reservation.status)}
                            {reservation.status}
                          </span>
                        </div>

                        <div className="booking-details">
                          <div className="booking-details-row">
                            <div className="booking-detail-item">
                              <span className="detail-label">Cliente</span>
                              <span className="detail-value">{reservation.userName}</span>
                            </div>
                            <div className="booking-detail-item">
                              <span className="detail-label">Email</span>
                              <span className="detail-value" style={{fontSize: '0.85rem'}}>{reservation.userEmail}</span>
                            </div>
                            <div className="booking-detail-item">
                              <span className="detail-label">Participantes</span>
                              <span className="detail-value">{reservation.numberOfParticipants}</span>
                            </div>
                          </div>

                          <div className="booking-details-row">
                            <div className="booking-detail-item">
                              <span className="detail-label">Preço Total</span>
                              <span className="detail-value" style={{fontSize: '1.1rem', color: '#0f172a'}}>€{reservation.totalPrice}</span>
                            </div>
                            
                            {reservation.paymentType && (
                              <>
                                <div className="booking-detail-item">
                                  <span className="detail-label">Tipo de Pagamento</span>
                                  <span className="detail-value" style={{
                                    color: reservation.paymentType === 'full' ? '#10b981' : '#f59e0b',
                                    fontWeight: 600,
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.5rem'
                                  }}>
                                    {reservation.paymentType === 'full' ? '' : 'ðŸ’°'}
                                    {reservation.paymentType === 'full' ? 'Pago Totalmente' : 'Caução (50%)'}
                                  </span>
                                </div>

                                {reservation.paymentType === 'deposit' && (
                                  <>
                                    <div className="booking-detail-item">
                                      <span className="detail-label">Pago</span>
                                      <span className="detail-value" style={{ color: '#10b981', fontWeight: 600 }}>
                                        €{(reservation.totalPrice / 2).toFixed(2)}
                                      </span>
                                    </div>
                                    <div className="booking-detail-item">
                                      <span className="detail-label">Falta Pagar</span>
                                      <span className="detail-value" style={{ color: '#f59e0b', fontWeight: 600 }}>
                                        €{(reservation.totalPrice / 2).toFixed(2)}
                                      </span>
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                          </div>
                        </div>

                        <div className="booking-actions">
                          <button
                            className="action-btn view"
                            onClick={() => {
                              setSelectedEventReservation(reservation);
                              setShowEventModal(true);
                            }}
                          >
                            <Eye size={18} />
                            Ver Detalhes
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      {showEventModal && selectedEventReservation && (
        <div className="modal-overlay" onClick={() => setShowEventModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">Detalhes da Reserva de Evento</h2>
              <button className="modal-close-btn" onClick={() => setShowEventModal(false)}>
                <X size={24} />
              </button>
            </div>

            <div className="modal-body">
              <div className="booking-detail-section">
                <div className="detail-title">
                  <div className="detail-title-icon">
                    <Calendar size={20} />
                  </div>
                  Informações do Evento
                </div>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">Evento</span>
                    <span className="detail-value">{selectedEventReservation.eventTitle}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Data e Hora</span>
                    <span className="detail-value">
                      {formatDate(selectedEventReservation.eventStartDate)}
                    </span>
                  </div>
                  {selectedEventReservation.eventEndDate && (
                    <div className="detail-item">
                      <span className="detail-label">Data de Término</span>
                      <span className="detail-value">
                        {formatDate(selectedEventReservation.eventEndDate)}
                      </span>
                    </div>
                  )}
                  <div className="detail-item">
                    <span className="detail-label">Número de Participantes</span>
                    <span className="detail-value">{selectedEventReservation.numberOfParticipants}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Preço Total</span>
                    <span className="detail-value">{selectedEventReservation.totalPrice}€</span>
                  </div>
                  
                  <div className="detail-item" style={{ gridColumn: '1 / -1', marginTop: '0.5rem', paddingTop: '0.75rem', borderTop: '2px solid #e2e8f0' }}>
                    <span className="detail-label" style={{ fontSize: '1rem', fontWeight: 600 }}>Tipo de Pagamento</span>
                    <span className="detail-value" style={{
                      color: (selectedEventReservation.paymentType === 'full') ? '#10b981' : '#f59e0b',
                      fontWeight: 700,
                      fontSize: '1.1rem'
                    }}>
                      {(selectedEventReservation.paymentType === 'full') 
                        ? ' Pago Totalmente' 
                        : 'ðŸ’° Caução (50%)'}
                    </span>
                  </div>
                  
                  {selectedEventReservation.paymentType === 'deposit' && (
                    <>
                      <div className="detail-item">
                        <span className="detail-label">Valor Pago (Caução)</span>
                        <span className="detail-value" style={{ color: '#10b981', fontWeight: 600 }}>
                          €{(selectedEventReservation.totalPrice / 2).toFixed(2)}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="detail-label">A Pagar no Dia</span>
                        <span className="detail-value" style={{ color: '#f59e0b', fontWeight: 600 }}>
                          €{(selectedEventReservation.totalPrice / 2).toFixed(2)}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className="booking-detail-section">
                <div className="detail-title">
                  <div className="detail-title-icon">
                    <Users size={20} />
                  </div>
                  Informações do Cliente
                </div>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">Nome</span>
                    <span className="detail-value">{selectedEventReservation.userName}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Email</span>
                    <span className="detail-value">{selectedEventReservation.userEmail}</span>
                  </div>
                  {selectedEventReservation.userPhone && (
                    <div className="detail-item">
                      <span className="detail-label">Telefone</span>
                      <span className="detail-value">{selectedEventReservation.userPhone}</span>
                    </div>
                  )}
                </div>
              </div>

              {selectedEventReservation.timeSlotReservations && selectedEventReservation.timeSlotReservations.length > 0 && (
                <div className="booking-detail-section">
                  <div className="detail-title">
                    <div className="detail-title-icon">
                      <Clock size={20} />
                    </div>
                    Horários Selecionados
                  </div>
                  <div className="time-slots-list">
                    {selectedEventReservation.timeSlotReservations.map((timeSlot, index) => (
                      <div key={index} className="time-slot-item">
                        <div className="time-slot-name">
                          <Clock size={16} />
                          {timeSlot.timeSlotName}
                        </div>
                        <div className="time-slot-details">
                          <span className="time-slot-time">
                            {timeSlot.startTime} - {timeSlot.endTime}
                          </span>
                          {timeSlot.specificDate && (
                            <span className="time-slot-date">
                              {new Date(timeSlot.specificDate).toLocaleDateString("pt-PT", { 
                                day: "2-digit", 
                                month: "2-digit", 
                                year: "numeric" 
                              })}
                            </span>
                          )}
                          {timeSlot.day && (
                            <span className="time-slot-day">
                              {timeSlot.day}
                            </span>
                          )}
                          <span className="time-slot-price">
                            {timeSlot.price}€
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedEventReservation.participants && selectedEventReservation.participants.length > 0 && (
                <div className="booking-detail-section">
                  <div className="detail-title">
                    <div className="detail-title-icon">
                      <Users size={20} />
                    </div>
                    Participantes
                  </div>
                  <div className="children-list">
                    {selectedEventReservation.participants && selectedEventReservation.participants.filter(p => p && p.nome).map((participant) => (
                      <div 
                        key={participant.id} 
                        className={`child-tag clickable ${participant.type === 0 || participant.type === 'Child' ? 'child-type' : 'adult-type'}`}
                        onClick={() => {
                          setSelectedChild(participant);
                          setShowChildModal(true);
                        }}
                        title="Clique para ver detalhes"
                      >
                        <Users size={16} />
                        {participant.nome}
                        <Eye size={14} className="child-tag-icon" />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

              {selectedEventReservation.status !== 'Cancelado' && selectedEventReservation.status !== 'Concluido' && (
                <div className="booking-admin-actions">
                  <button 
                    className="btn btn-edit"
                    onClick={() => handleEditEventReservation(selectedEventReservation)}
                    title="Editar Reserva de Evento"
                  >
                    <Edit2 size={18} />
                    Editar
                  </button>
                  <button 
                    className="btn btn-cancel-booking"
                    onClick={() => handleCancelEventReservation(selectedEventReservation)}
                    title="Cancelar Reserva de Evento"
                  >
                    <Trash2 size={18} />
                    Cancelar
                  </button>
                </div>
              )}

            <div className="modal-actions">
              <button className="btn btn-close" onClick={() => setShowEventModal(false)}>
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      {showModal && selectedBooking && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2 className="modal-title">Detalhes do Agendamento</h2>
              <button className="modal-close-btn" onClick={() => setShowModal(false)}>
                <X size={24} />
              </button>
            </div>

            <div className="modal-body">
              <div className="booking-detail-section">
                <div className="detail-title">
                  <div className="detail-title-icon">
                    <Calendar size={20} />
                  </div>
                  Informações do Serviço
                </div>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">Serviço</span>
                    <span className="detail-value">{selectedBooking.servicoNome}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Data</span>
                    <span className="detail-value">
                      {formatDate(selectedBooking.dataHora)}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Horário</span>
                    <span className="detail-value" style={{ 
                      fontWeight: 600, 
                      color: '#2c5f6f',
                      fontSize: '1.05rem'
                    }}>
                       {formatTime(selectedBooking.dataHora)}
                    </span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Duração</span>
                    <span className="detail-value">{selectedBooking.duracao}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Preço</span>
                    <span className="detail-value">{selectedBooking.preco}</span>
                  </div>
                  {selectedBooking.paymentType && (
                    <>
                      <div className="booking-detail-item">
                        <span className="detail-label">Tipo de Pagamento</span>
                        <span className="detail-value" style={{
                          color: selectedBooking.paymentType === 'full' ? '#10b981' : '#f59e0b',
                          fontWeight: 600
                        }}>
                          {selectedBooking.paymentType === 'full' 
                            ? ' Pago Totalmente' 
                            : 'Caução (50%)'}
                        </span>
                      </div>
                      {selectedBooking.paymentType === 'deposit' && (
                        <>
                          <div className="booking-detail-item">
                            <span className="detail-label">Valor Pago</span>
                            <span className="detail-value" style={{ color: '#10b981', fontWeight: 600 }}>
                              €{(parseFloat(selectedBooking.preco.replace('€','').replace(',','.')) / 2).toFixed(2)}
                            </span>
                          </div>
                          <div className="booking-detail-item">
                            <span className="detail-label">A Pagar no Dia</span>
                            <span className="detail-value" style={{ color: '#f59e0b', fontWeight: 600 }}>
                              €{(parseFloat(selectedBooking.preco.replace('€','').replace(',','.')) / 2).toFixed(2)}
                            </span>
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {selectedBooking.servicoTipo === 'FestaAniversario' && selectedBooking.numeroParticipantes && (
                    <div className="detail-item">
                      <span className="detail-label">Participantes</span>
                      <span className="detail-value">{selectedBooking.numeroParticipantes} crianças</span>
                    </div>
                  )}
                </div>
              </div>

              <div className="booking-detail-section">
                <div className="detail-title">
                  <div className="detail-title-icon">
                    <User size={20} />
                  </div>
                  Informações do Cliente
                </div>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">Nome</span>
                    <span className="detail-value">{selectedBooking.userName || 'N/A'}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Email</span>
                    <span className="detail-value">{selectedBooking.userEmail || 'N/A'}</span>
                  </div>
                  {selectedBooking.userTelefone && (
                    <div className="detail-item">
                      <span className="detail-label">Telefone</span>
                      <span className="detail-value">{selectedBooking.userTelefone}</span>
                    </div>
                  )}
                </div>
              </div>

              {selectedBooking.participants && selectedBooking.participants.length > 0 && (
                <div className="booking-detail-section">
                  <div className="detail-title">
                    <div className="detail-title-icon">
                      <Users size={20} />
                    </div>
                    Participantes
                  </div>
                  <div className="children-list">
                    {selectedBooking.participants && selectedBooking.participants.filter(p => p && p.nome).map((participant) => (
                      <div 
                        key={participant.id} 
                        className={`child-tag clickable ${participant.type === 0 || participant.type === 'Child' ? 'child-type' : 'adult-type'}`}
                        onClick={() => {
                          setSelectedChild(participant);
                          setShowChildModal(true);
                        }}
                        title="Clique para ver detalhes"
                      >
                        <Users size={16} />
                        {participant.nome}
                        <Eye size={14} className="child-tag-icon" />
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedBooking.servicoNome === 'Festa de aniversário' && (
                <div className="booking-detail-section">
                  <div className="detail-title">
                    <div className="detail-title-icon">
                      <Users size={20} />
                    </div>
                    Participantes da Festa
                  </div>
                  {selectedBooking.partyParticipants && selectedBooking.partyParticipants.length > 0 ? (
                    <div className="participants-table">
                      <table className="participants-data-table">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Nome da Criança</th>
                            <th>Encarregado</th>
                            <th>Contacto</th>
                            <th>Cacifo</th>
                            <th>Presente</th>
                          </tr>
                        </thead>
                        <tbody>
                          {selectedBooking.partyParticipants.map((participant, index) => (
                            <tr key={participant.id}>
                              <td>{index + 1}</td>
                              <td>{participant.nomeCrianca}</td>
                              <td>{participant.nomeEncarregado}</td>
                              <td>{participant.contactoEncarregado}</td>
                              <td>
                                <input
                                  type="text"
                                  value={participant.cacifo || ''}
                                  onChange={(e) => handleCacifoChange(participant.id, e.target.value)}
                                  placeholder="NÂº"
                                  className="cacifo-input"
                                  style={{width: '60px', padding: '4px 8px', textAlign: 'center'}}
                                />
                              </td>
                              <td>
                                <input
                                  type="checkbox"
                                  checked={participant.isPresent || false}
                                  onChange={() => handleTogglePresence(participant.id, !participant.isPresent)}
                                  className="presence-checkbox"
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <div className="participants-summary">
                        <strong>Total:</strong> {selectedBooking.partyParticipants.length} participante(s)
                        <span style={{marginLeft: '20px'}}>
                          <strong>Presentes:</strong> {selectedBooking.partyParticipants.filter(p => p.isPresent).length}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="no-participants-warning">
                      <AlertCircle size={20} />
                      <span>Nenhum participante registado para esta festa</span>
                    </div>
                  )}
                </div>
              )}

              {selectedBooking.observacoes && (
                <div className="booking-detail-section">
                  <div className="detail-title">
                    <div className="detail-title-icon">
                      <AlertCircle size={20} />
                    </div>
                    Observações
                  </div>
                  <div className="detail-item">
                    <p className="detail-value multiline">{selectedBooking.observacoes}</p>
                  </div>
                </div>
              )}
            </div>

            <div className="modal-actions">
              {selectedBooking.status !== 'Cancelado' && selectedBooking.status !== 'Concluido' && (
                <div className="booking-admin-actions">
                  <button 
                    className="btn btn-edit"
                    onClick={() => handleEditBooking(selectedBooking)}
                    title="Editar Reserva"
                  >
                    <Edit2 size={18} />
                    Editar
                  </button>
                  <button 
                    className="btn btn-cancel-booking"
                    onClick={() => handleCancelBooking(selectedBooking)}
                    title="Cancelar Reserva"
                  >
                    <Trash2 size={18} />
                    Cancelar
                  </button>
                </div>
              )}
              <button className="btn btn-close" onClick={() => setShowModal(false)}>
                Fechar
              </button>
            </div>
          </div>
          <CustomAlert {...alertProps} />
        </div>
      )}

      {showChildModal && selectedChild && (
  <div className="modal-overlay child-modal-overlay" onClick={() => setShowChildModal(false)}>
    <div className="modal child-details-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <div className="modal-header-content">
          <div className="child-modal-avatar">
            <Users size={32} />
          </div>
          <div>
            <h2 className="modal-title">{selectedChild.nome}</h2>
            <p className="modal-subtitle">
              {calculateAge(selectedChild.dataNascimento)} anos
            </p>
          </div>
        </div>
        <button className="modal-close-btn" onClick={() => setShowChildModal(false)}>
          <X size={24} />
        </button>
      </div>

      <div className="modal-body child-modal-body">
        <div className="child-info-section">
          <div className="child-section-header">
            <User size={20} />
            <h3>Informações Pessoais</h3>
          </div>
          <div className="child-info-grid">
            <div className="child-info-item">
              <span className="child-info-label">Nome Completo</span>
              <span className="child-info-value">{selectedChild.nome}</span>
            </div>
            <div className="child-info-item">
              <span className="child-info-label">Data de Nascimento</span>
              <span className="child-info-value">
                {formatDate(selectedChild.dataNascimento)} ({calculateAge(selectedChild.dataNascimento)} anos)
              </span>
            </div>
            <div className="child-info-item">
              <span className="child-info-label">Cartão de Cidadão</span>
              <span className="child-info-value">{selectedChild.cartaoCidadao}</span>
            </div>
            <div className="child-info-item">
              <span className="child-info-label">NIF</span>
              <span className="child-info-value">{selectedChild.nif}</span>
            </div>
            <div className="child-info-item">
              <span className="child-info-label">Válido Até</span>
              <span className="child-info-value">{formatDate(selectedChild.validoAte)}</span>
            </div>
            <div className="child-info-item full-width">
              <span className="child-info-label">Estabelecimento de Ensino</span>
              <span className="child-info-value">{selectedChild.estabelecimentoEnsino}</span>
            </div>
          </div>
        </div>

        <div className="child-info-section">
          <div className="child-section-header">
            <AlertCircle size={20} />
            <h3>Informações de Saúde</h3>
          </div>
          <div className="child-health-grid">
            {selectedChild.alergias && (
              <div className="health-card">
                <div className="health-card-header">
                  <AlertCircle size={18} />
                  <h4>Alergias</h4>
                </div>
                <p className="health-card-content">{selectedChild.alergias}</p>
              </div>
            )}
            {selectedChild.alimentosProibidos && (
              <div className="health-card">
                <div className="health-card-header">
                  <XCircle size={18} />
                  <h4>Alimentos Proibidos</h4>
                </div>
                <p className="health-card-content">{selectedChild.alimentosProibidos}</p>
              </div>
            )}
            {selectedChild.medicacaoFrequente && (
              <div className="health-card">
                <div className="health-card-header">
                  <Activity size={18} />
                  <h4>Medicação Frequente</h4>
                </div>
                <p className="health-card-content">{selectedChild.medicacaoFrequente}</p>
              </div>
            )}
            {selectedChild.necessidadesEducativas && (
              <div className="health-card">
                <div className="health-card-header">
                  <AlertCircle size={18} />
                  <h4>Necessidades Educativas</h4>
                </div>
                <p className="health-card-content">{selectedChild.necessidadesEducativas}</p>
              </div>
            )}
            {selectedChild.outrosAspectos && (
              <div className="health-card full-width">
                <div className="health-card-header">
                  <AlertCircle size={18} />
                  <h4>Outros Aspectos</h4>
                </div>
                <p className="health-card-content">{selectedChild.outrosAspectos}</p>
              </div>
            )}
            {!selectedChild.alergias && 
             !selectedChild.alimentosProibidos && 
             !selectedChild.medicacaoFrequente && 
             !selectedChild.necessidadesEducativas && 
             !selectedChild.outrosAspectos && (
              <div className="no-health-info">
                <CheckCircle size={24} />
                <p>Nenhuma restrição ou condição de saúde registada</p>
              </div>
            )}
          </div>
        </div>

        {selectedChild.pessoasAutorizadas && parsePessoasAutorizadas(selectedChild.pessoasAutorizadas).length > 0 && (
          <div className="child-info-section">
            <div className="child-section-header">
              <Users size={20} />
              <h3>Pessoas Autorizadas</h3>
            </div>
            <div className="authorized-persons-grid">
              {parsePessoasAutorizadas(selectedChild.pessoasAutorizadas).map((pessoa, index) => (
                <div key={index} className="authorized-person-card">
                  <div className="authorized-person-icon">
                    <User size={24} />
                  </div>
                  <div className="authorized-person-info">
                    <h4>{pessoa.nome}</h4>
                    <div className="authorized-person-details">
                      <span>
                        <strong>CC:</strong> {pessoa.cartaoCidadao}
                      </span>
                      <span>
                        <strong>Tel:</strong> {pessoa.telefone}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="child-info-section">
          <div className="child-section-header">
            <Calendar size={20} />
            <h3>Informação de Registro</h3>
          </div>
          <div className="child-info-grid">
            <div className="child-info-item">
              <span className="child-info-label">Registado em</span>
              <span className="child-info-value">
                {formatDate(selectedChild.createdAt)}
              </span>
            </div>
            {selectedChild.updatedAt && (
              <div className="child-info-item">
                <span className="child-info-label">Ãšltima Atualização</span>
                <span className="child-info-value">
                  {formatDate(selectedChild.updatedAt)}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="modal-actions">
        <button className="btn btn-close" onClick={() => setShowChildModal(false)}>
          Fechar
        </button>
      </div>
    </div>
  </div>
)}

      {showDayBookingsModal && selectedDate && (
  <div className="modal-overlay" onClick={() => setShowDayBookingsModal(false)}>
    <div className="modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h2 className="modal-title">
          Marcações de {selectedDate.toLocaleDateString('pt-PT', { 
            day: 'numeric', 
            month: 'long', 
            year: 'numeric' 
          })}
        </h2>
        <button className="modal-close-btn" onClick={() => setShowDayBookingsModal(false)}>
          <X size={24} />
        </button>
      </div>

      <div className="modal-body">
        {selectedDayBookings.length === 0 ? (
          <div className="day-bookings-empty">
            <Calendar size={48} />
            <p>Sem marcações para este dia</p>
          </div>
        ) : (
          <div className="day-bookings-list">
            {selectedDayBookings.map((booking, index) => (
              <div
                key={index}
                className={`day-booking-card ${booking.isEventReservation ? 'evento' : booking.status?.toLowerCase()}`}
                onClick={() => {
                  setShowDayBookingsModal(false);
                  if (booking.isEventReservation) {
                    setSelectedEventReservation(booking);
                    setShowEventModal(true);
                  } else {
                    setSelectedBooking(booking);
                    setShowModal(true);
                  }
                }}
              >
                <div className="booking-card-header">
                  <h3 className="booking-card-title">
                    {booking.isEventReservation ? booking.eventTitle : booking.servicoNome}
                  </h3>
                  <div className="booking-card-time">
                    <Clock size={16} />
                    {booking.isEventReservation 
                      ? formatTime(booking.eventStartDate)
                      : formatTime(booking.dataHora)
                    }
                  </div>
                </div>
                <div className="booking-card-details">
                  <div className="booking-card-detail-item">
                    <Users size={16} />
                    <span>
                      {booking.isEventReservation 
                        ? booking.userName 
                        : (booking.participants && booking.participants.length > 0 
                            ? booking.participants.filter(p => p && p.nome).map(p => p.nome).join(', ') 
                            : booking.userName || 'Sem participantes')
                      }
                    </span>
                  </div>
                  {!booking.isEventReservation && (
                    <div className="booking-card-detail-item">
                      <span className={`status-badge ${booking.status.toLowerCase()}`}>
                        {getStatusIcon(booking.status)}
                        {booking.status}
                      </span>
                    </div>
                  )}
                  {booking.isEventReservation && (
                    <>
                      <div className="booking-card-detail-item">
                        <Users size={16} />
                        <span>{booking.numberOfParticipants} participantes</span>
                      </div>
                      <div className="booking-card-detail-item">
                        <span className={`status-badge ${booking.status?.toLowerCase() || 'pendente'}`}>
                          {getStatusIcon(booking.status)}
                          {booking.status}
                        </span>
                      </div>
                    </>
                  )}
                </div>
                {!booking.isEventReservation && booking.status !== 'Cancelado' && booking.status !== 'Concluido' && (
                  <div className="booking-card-actions">
                    <button
                      className="action-btn edit-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDayBookingsModal(false);
                        handleEditBooking(booking);
                      }}
                      title="Editar"
                    >
                      <Edit2 size={16} />
                    </button>
                    <button
                      className="action-btn cancel-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCancelBooking(booking);
                      }}
                      title="Cancelar"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                )}
                {booking.isEventReservation && booking.status !== 'Cancelado' && booking.status !== 'Concluido' && (
                  <div className="booking-card-actions">
                    <button
                      className="action-btn edit-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        setShowDayBookingsModal(false);
                        handleEditEventReservation(booking);
                      }}
                      title="Editar"
                    >
                      <Edit2 size={16} />
                    </button>
                    <button
                      className="action-btn cancel-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleCancelEventReservation(booking);
                      }}
                      title="Cancelar"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {/* NOVO: Botões de ação com o novo botão "Criar Booking" */}
      <div className="modal-actions">
        <button 
          className="btn btn-create-booking"
          onClick={() => {
            setSelectedDateForBooking(selectedDate);
            setShowCreateBookingModal(true);
          }}
        >
          <Plus size={20} />
          Criar Reserva
        </button>
        <button className="btn btn-close" onClick={() => setShowDayBookingsModal(false)}>
          Fechar
        </button>
      </div>
    </div>
  </div>
)}
      <AdminCreateBookingModal
        show={showCreateBookingModal}
        onClose={() => setShowCreateBookingModal(false)}
        onSuccess={() => {
          setShowCreateBookingModal(false);
        }}
        selectedDate={selectedDateForBooking}
      />
      <AdminEditBookingModal
        show={showEditModal}
        onClose={() => setShowEditModal(false)}
        booking={bookingToEdit}
        onSuccess={handleEditSuccess}
      />
      <AdminEditEventModal
        show={showEditEventModal}
        onClose={() => setShowEditEventModal(false)}
        eventReservation={eventToEdit}
        onSuccess={handleEditEventSuccess}
      />
    </>
  );
}